// eslint-disable-next-line no-use-before-define
import React, { Suspense, useEffect } from 'react';
import { LoadingAnimation } from '../../elements/LoadingAnimation/LoadingAnimation';
import { setPageTitle } from '../../utilities/PageTitleUtil/PageTitleUtil';

const LoadedAdminPage = React.lazy(() => import('./AdminPage').then(({ AdminPage }) => ({ default: AdminPage })));

export const LoadableAdminPage = () => {
  useEffect(() => setPageTitle('Admin'), []);

  return <Suspense fallback={<LoadingAnimation />}>
    <LoadedAdminPage />
  </Suspense>;
};
